import { useEffect, useState } from "react";
import { modesService } from "@/services";

// Live limited-time mode (or null). Polls every 60s so a window
// expiring mid-session updates without a reload. Used by the
// dashboard daily tile and the daily-challenge page so they stay
// visually in sync about today's flavour.
export function useActiveMode() {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      modesService
        .getActive()
        .then((data) => !cancelled && setMode(data?.items?.[0] || null))
        .catch(() => !cancelled && setMode(null));
    };
    load();
    const poll = window.setInterval(load, 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(poll);
    };
  }, []);

  return mode;
}
